export const TOKEN_SUBMIT = 'untrust.form1.submit.fetching',
  TOKEN_SUBMIT_SUCCESS = 'untrust.form1.submit.success',
  TOKEN_SUBMIT_ERROR = 'untrust.form1.submit.failed';



// WEBPACK FOOTER //
// ./src/views/trust/_types.js